import React from 'react';
import Button from 'react-bootstrap/Button';
import SearchBar from '../../../../searchbar/SearchBar';
import VerificationService from '../../../../../service/VerificationService';

export default class NcDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dlNumber: '',
      hasManualUnlock: null,
    };

    this.comboFields = [
      {
        value: 'dlNumber',
        display: 'Driver License Number',
      },
    ];
  }

  getIdentityVerifications(event) {
    const { search, } = event;
    this.reset();

    const vm = this;
    const key = search.value;
    const soid = 'nc_drivers_license';

    VerificationService.hasManualUnlock(soid, key)
      .then((response) => {
        const hasManualUnlock = response.data.contents;
        vm.setState({
          dlNumber: search.value,
          hasManualUnlock,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  createManualUnlock(dlNumber) {
    const key = dlNumber;
    const soid = 'nc_drivers_license';

    VerificationService.createManualUnlock(soid, key, 24)
      .then(() => {})
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
      });
  }

  reset() {
    this.setState({
      dlNumber: '',
      hasManualUnlock: null,
    });
  }

  render() {
    const {
      dlNumber,
      hasManualUnlock,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getIdentityVerifications(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <div>
            <p>{`Has Manual Unlock: ${JSON.stringify(hasManualUnlock === undefined || hasManualUnlock === null ? null : hasManualUnlock)}`}</p>
            <hr />
          </div>
          {hasManualUnlock === false
            && <div>
              <Button variant="primary" onClick={() => this.createManualUnlock(dlNumber)}>
                Create Manual Unlock
              </Button>
            </div>
          }
        </div>
      </div>
    );
  }
}
